import { c as _c } from "react-compiler-runtime";
import { memo } from 'react';
import ResizableSortTH from '../../resizing/components/ResizableSortTH';
import { jsx as _jsx } from "react/jsx-runtime";
const Header = t0 => {
  const $ = _c(15);
  const {
    column,
    columnIndex,
    columnPosition,
    isLastColumn,
    sortDirection,
    onColumnWidthChange,
    onColumnOrderChange,
    onSortChange,
    numberOfFrozenColumns
  } = t0;
  let t1;
  if ($[0] !== column.HeaderContentComponent || $[1] !== column.columnName || $[2] !== column.columnNamespace) {
    t1 = /*#__PURE__*/_jsx(column.HeaderContentComponent, {
      columnNamespace: column.columnNamespace,
      columnName: column.columnName
    });
    $[0] = column.HeaderContentComponent;
    $[1] = column.columnName;
    $[2] = column.columnNamespace;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== column || $[5] !== columnIndex || $[6] !== columnPosition || $[7] !== isLastColumn || $[8] !== numberOfFrozenColumns || $[9] !== onColumnOrderChange || $[10] !== onColumnWidthChange || $[11] !== onSortChange || $[12] !== sortDirection || $[13] !== t1) {
    t2 = /*#__PURE__*/_jsx(ResizableSortTH, {
      column: column,
      columnIndex: columnIndex,
      columnPosition: columnPosition,
      isLastColumn: isLastColumn,
      numberOfFrozenColumns: numberOfFrozenColumns,
      sortDirection: sortDirection,
      onColumnWidthChange: onColumnWidthChange,
      onColumnOrderChange: onColumnOrderChange,
      onSortChange: onSortChange,
      children: t1
    });
    $[4] = column;
    $[5] = columnIndex;
    $[6] = columnPosition;
    $[7] = isLastColumn;
    $[8] = numberOfFrozenColumns;
    $[9] = onColumnOrderChange;
    $[10] = onColumnWidthChange;
    $[11] = onSortChange;
    $[12] = sortDirection;
    $[13] = t1;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  return t2;
};
export default /*#__PURE__*/memo(Header);